module.exports = __webpack_public_path__ + "media/images/service/n_4-bf0178d5e10ccda4bf217166d0e26fc5.jpg";